import React, { ReactNode } from 'react';

import Checkbox, { CheckboxState } from '@adsk/alloy-react-checkbox';
import { useTheme } from '@adsk/alloy-react-styles';

const FooterOption = ({
  label,
  defaultChecked,
  onChange,
}: {
  label: ReactNode;
  defaultChecked?: boolean;
  onChange?: (
    state: CheckboxState,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
}) => {
  const { tokens } = useTheme();
  const labelTokens = tokens?.component?.footer?.option?.label;

  return (
    <label
      css={[
        {
          display: 'flex',
          marginRight: 8,
        },
        labelTokens?._,
      ]}
    >
      <Checkbox
        onChange={onChange}
        defaultChecked={defaultChecked}
        style={{ marginRight: 8 }}
      />
      <span dir="auto">{label}</span>
    </label>
  );
};

export default FooterOption;
